module.exports = __webpack_public_path__ + "static/modern-homes-36b1832ec514122c56daa00b472131f4.png";